import React from "react";
import Explainer from "../ExplainerModal";

const UserManagementExplainer = () => {
  return (
    <Explainer
      title="👥 User Management Explainer"
      content={
        <>
          <p>
            The <strong>User Management</strong> section provides administrators with an overview of all registered users on the platform, including their status, location, and access level.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            📋 User List Overview
          </h3>
          <p>
            This section displays a list of all users, along with their status, either <strong>Active</strong> or <strong>Inactive</strong>.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🔍 Viewing User Details
          </h3>
          <p>
            To view details of a specific user, click on their <strong>name</strong>, and you will be redirected to their profile information page.
          </p>
        </>
      }
    />
  );
};

export default UserManagementExplainer;
